module.exports = __webpack_public_path__ + "img/DE03947.5295167b.png";